import React from 'react'
import { Stack, Typography, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TemporaryIcon from 'components/global/TemporaryIcon'
import Filters from '../../components/Filters'
import PeriodWidgetSkeleton from '../../Skeletons/PeriodWidgetSkeleton'

interface PeriodWidgetProps {
  loading?: boolean
  isEvolutionMode?: boolean
}

const PeriodWidget: React.FC<PeriodWidgetProps> = ({ loading = false, isEvolutionMode = false }) => {
  const { t } = useTranslation()

  if (loading) {
    return <PeriodWidgetSkeleton />
  }

  return (
    <Box
      sx={{
        width: { xs: '100%', sm: '50%', md: '15%' },
        border: '1px solid #EFEFEF',
        borderRadius: '16px',
        padding: 2,
        backgroundColor: '#F7F7F7',
        minHeight: '100px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Stack spacing={2} alignItems="center" sx={{ width: '100%', flex: 1 }}>
        <Stack spacing={0.5} alignItems="center">
          <TemporaryIcon 
            iconlabel="calendar-range" 
            iconsize="16px"
            iconcolor={'#1976d2'}
          />
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '12px',
              textTransform: 'uppercase',
              textAlign: 'center',
              color: 'inherit'
            }}
          >
            {t('stats.traffic.widgets.period.title')}
          </Typography>
        </Stack>
        
        <Box sx={{ 
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          '& .MuiTextField-root': {
            width: '100%'
          },
          '& .MuiOutlinedInput-root': {
            fontSize: '9px',
            height: '28px',
            minHeight: '28px'
          },
          '& .MuiSelect-select': {
            fontSize: '9px',
            padding: '4px 8px',
            display: 'flex',
            alignItems: 'center'
          },
          '& .MuiInputBase-input': {
            padding: '4px 8px'
          },
          '& .MuiSvgIcon-root': {
            fontSize: '14px'
          }
        }}>
          <Filters 
            section={'globals'} 
            isSmall={true} 
            isEvolutionMode={isEvolutionMode}
          />
        </Box>
      </Stack>
    </Box>
  )
}

export default PeriodWidget